var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portfoliosTotal"},[_c('div',{staticClass:"ptValueInfos"},[_c('div',{staticClass:"ptValueCurrency"},[_vm._v(_vm._s(_vm.allPortfoliosCurrency))]),_c('div',{staticClass:"ptValue"},[_vm._v(_vm._s(_vm.allPortfoliosTotal))])]),_c('ValueAndChange',_vm._b({},'ValueAndChange',_vm.portfoliosTotalChange,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }